module.exports = __webpack_public_path__ + "static/swl-cd4e99a5616e107c3a0934e0960fcddb.jpeg";